import { render, staticRenderFns } from "./JobRuns.yaml?vue&type=template&id=c25494ee&component"
import script from "./JobRuns.yaml?vue&type=script&lang=ts&component"
export * from "./JobRuns.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports